import { SendTicketsSection } from 'features/SendTickets/SendTickets.styles';
import { Text } from 'features/common/components/Text';
import { Button as UnstyledBtn } from 'features/common/components/Button';
import styled from 'styled-components';

export const Root = styled(SendTicketsSection)`
	background-color: ${({ theme }) => theme.colors.whitePearl};
	align-items: center;
	width: 100%;
`;

export const ConfirmationCard = styled.div`
	box-sizing: border-box;
	padding: 32px;
	background-color: #f5f5f5;
	border-radius: 8px;
	font-family: ${({ theme }) => theme.fonts.primary};
	display: flex;
	flex-direction: column;
	align-items: center;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const ConfirmationText = styled(Text)`
	font-size: 18px;
	width: 100%;
	justify-content: flex-start;
	color: ${({ theme }) => theme.colors.black};
`;

export const Button = styled(UnstyledBtn)`
	width: fit-content;
	height: fit-content;
	margin: 0;
	width: 100%;

	:disabled {
		background: ${({ theme }) => theme.colors.grey9};
	}
`;

export const Price = styled.p`
	display: flex;
	justify-content: space-between;
	border-top: 1px solid ${({ theme }) => theme.colors.black};
	padding: 24px 0;
	width: 100%;
	color: ${({ theme }) => theme.colors.black};
`;
